module.exports = __webpack_public_path__ + "static/media/allee.e6264de5.svg";